export default "__VITE_ASSET__BbbQvdDW__"